<app-alert *ngIf="helperService.showAlert" [type]=helperService.typeAlert [Message]=helperService.messageAlert></app-alert>
<div class="container-fluid content-container">

    <div class="content-container">


      <mat-card>
        <mat-card class="Info-Advisor">
          <mat-card-content>
            <div class="header-containerw">
              <div class="row">

              </div>
              <div class="header-controlsw">
                <button
                  mat-button
                  *ngFor="let control of controls"
                  (click)="createClient()"
                >
                  <i [ngClass]="control.icon"
                    >&nbsp; &nbsp;{{ "NewClient" | translate }}</i
                  >
                </button>
              </div>
            </div>
          </mat-card-content>

          <mat-card class="advisor-grid-container">

              <div class="loading-containerAdvisor" *ngIf="!ClientLoading">
                <div  class="pulsing">
                  <mat-spinner [diameter]="50" ></mat-spinner>
                </div>
                <p class="pulsing">{{"Loading" | translate}}</p>
              </div>


            <div class="row">
              <div class="col">
                <table class="table table-striped" style="width: 100%">
                  <thead>
                    <tr class="advisor-grid-headers">
                      <th scope="col">{{ "TypeIdentification" | translate }}</th>
                      <th
                        scope="col"

                      >
                        {{ "NumberIdentification" | translate }}
                      </th>
                      <th scope="col">{{ "FirsnameClient" | translate }}</th>
                      <th scope="col">{{ "LastnameClient" | translate }}</th>
                      <th scope="col">{{ "Email" | translate }}</th>
                      <th scope="col">{{ "Actions" | translate }}</th>
                    </tr>

                    <tr class="advisor-grid-inputs">
                      <th scope="col">
                        <div class="col-lg-12">
                          <mat-form-field>
                            <mat-label>{{ "Filter" | translate }}</mat-label>
                            <input
                              matInput
                              type="text"
                              [(ngModel)]="FilterTypeName"
                              (ngModelChange)="resetPagination()"
                            />
                          </mat-form-field>
                        </div>
                      </th>
                      <th scope="col">
                        <div class="col-lg-12">
                          <mat-form-field>
                            <mat-label>{{ "Filter" | translate }}</mat-label>
                            <input
                              matInput
                              type="text"
                              [(ngModel)]="FilterIdentification"
                              (ngModelChange)="resetPagination()"
                            />
                          </mat-form-field>
                        </div>
                      </th>

                      <th
                        scope="col"

                      >
                          <div class="col-lg-12">
                            <mat-form-field>
                              <mat-label>{{ "Filter" | translate }}</mat-label>
                              <input
                                matInput
                                type="text"
                                [(ngModel)]="FilterFirstName"
                                (ngModelChange)="resetPagination()"
                              />
                            </mat-form-field>

                          </div>

                      </th>
                      <th
                        scope="col"

                      >
                          <div class="col-lg-12">
                            <mat-form-field>
                              <mat-label>{{ "Filter" | translate }}</mat-label>
                              <input
                                matInput
                                type="text"
                                [(ngModel)]="FilterLastName"
                                (ngModelChange)="resetPagination()"
                              />
                            </mat-form-field>

                          </div>

                      </th>
                      <th scope="col">

                          <div class="col-lg-12">
                            <mat-form-field>
                              <mat-label>{{ "Filter" | translate }}</mat-label>
                              <input
                                matInput
                                type="text"
                                [(ngModel)]="FilterEmail"
                                (ngModelChange)="resetPagination()"
                              />
                            </mat-form-field>
                          </div>

                      </th>
                      <th scope="col">

                      </th>
                    </tr>
                  </thead>

                  <tbody *ngIf="ClientLoading" >
                    <tr

                      *ngFor="
                        let ClientData of ClientData  | filterClientManagement: FilterEmail: FilterFirstName: FilterLastName: FilterTypeName: FilterIdentification
                        | slice : desde : hasta;
                        let index = index
                      "
                    >
                      <td>
                        {{ ClientData.TypeName }}
                      </td>

                      <td>
                        {{ClientData.Identification}}
                      </td>
                      <td>
                        {{ ClientData.FirstName }}
                      </td>
                      <td>
                        {{ ClientData.LastName}}
                      </td>
                      <td>
                        {{ ClientData.Email }}
                      </td>
                      <td style="width: 16%">
                        <div class="grid-controls">
                          <button class="action-btn col-lg-3">
                            <i
                              class="material-icons-outlined"
                              (click)="EditInfoclient(ClientData)"
                              matTooltip="{{ 'EditInformationCLient' | translate }}"
                            >
                              create
                            </i>
                          </button>



                          <button class="action-btn col-lg-3">
                            <i
                              class="material-icons-outlined"
                              (click)="DeleteClient(ClientData)"
                              matTooltip="{{ 'DeleteClient' | translate }}"
                            >
                              delete
                            </i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row advisor-grid-footer">
              <mat-divider></mat-divider>
            </div>
            <div class="row grid-pagination-container" *ngIf="ClientLoading" >
              <mat-paginator
                [length]="(ClientData  | filterClientManagement: FilterEmail: FilterFirstName: FilterLastName: FilterTypeName: FilterIdentification)?.length"
                [pageSize]="pagesize"
                [pageSizeOptions]="[4, 8, 16, 32]"
                aria-label="Select page"
                (page)="changePage($event)"
                showFirstLastButtons
              >
              </mat-paginator>
            </div>
          </mat-card>
        </mat-card>
      </mat-card>
    </div>
  </div>
